export const MECANICA_SERVICES_DATA = [
    {
      slug: "diagnosis",
      title: "Diagnosis",
      description: `Disponemos de equipos de última generación para la diagnosis 
      electrónica de tu coche. Detectamos y localizamos cualquier fallo en los 
      sistemas de inyección, airbags, ABS, motores y centralitas, evitando 
      averías mayores y costosas. Nuestro personal está continuamente en 
      formación para manejar las herramientas de diagnóstico más avanzadas, 
      dándote la tranquilidad de un informe preciso y detallado de las 
      necesidades de tu vehículo.`,

      checklist: [
        "Lectura y borrado de códigos de error",
        "Verificación de sensores y módulos",
        "Informe detallado de fallos detectados",
        "Actualizaciones de software en centralitas",
      ],
    },
    {
      slug: "embrague-distribucion",
      title: "Embrague y Distribución",
      description: `El mantenimiento del embrague y la correa de distribución 
      es esencial para el funcionamiento y la seguridad de tu coche. Un 
      embrague desgastado puede provocar tirones o pérdida de tracción, 
      mientras que una correa defectuosa podría causar graves daños al motor. 
      En LealChapaYPintura.com revisamos y sustituimos estos componentes con 
      piezas originales o equivalentes de alta calidad, asegurando la máxima 
      fiabilidad de tu vehículo.`,

      checklist: [
        "Reemplazo de kit de embrague completo",
        "Cambio de correa y tensores de distribución",
        "Uso de recambios homologados",
        "Garantía de mano de obra y piezas",
      ],
    },
    {
      slug: "pre-itv",
      title: "Pre ITV",
      description: `Evita sorpresas y gastos innecesarios realizando una 
      revisión Pre ITV con nosotros. Inspeccionamos todos los puntos clave 
      que se evaluarán en la Inspección Técnica de Vehículos: sistemas de 
      frenos, luces, neumáticos, emisiones, etc. Te entregamos un informe 
      detallado y, si es necesario, podemos hacer las reparaciones al 
      instante para que vayas a la ITV con la máxima seguridad y confianza.`,
  
      checklist: [
        "Revisión completa de frenos y suspensión",
        "Chequeo de alumbrado y señalización",
        "Diagnóstico de emisiones contaminantes",
        "Ajustes y reparaciones inmediatas",
      ],
    },
    {
      slug: "neumaticos",
      title: "Neumáticos",
      description: `La seguridad en carretera depende en gran medida del 
      estado de tus neumáticos. Ofrecemos venta y montaje de neumáticos de 
      primeras marcas, equilibrados y alineados para un desgaste uniforme. 
      Además, controlamos la presión y profundidad del dibujo para asegurar 
      un agarre óptimo en cualquier condición. Si buscas un asesoramiento 
      profesional sobre el tipo de neumático que mejor se adapta a tu estilo 
      de conducción, ¡estás en el lugar correcto!`,

      checklist: [
        "Venta de neumáticos de primeras marcas",
        "Equilibrado y alineación de ruedas",
        "Control de presión y desgaste",
        "Asesoría en neumáticos de invierno o verano",
      ],
    },
  ];
  